// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,body,#app,.app{height:100%}.visually-hidden{width:0;height:0;visibility:hidden}`, "",{"version":3,"sources":["webpack://./src/ContactsApp.vue"],"names":[],"mappings":"AAEA,oBAIE,WAAA,CAIF,iBACE,OAAA,CACA,QAAA,CACA,iBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
